const postCategoriesDefaultState = {
  data: [],
  loading: false,
  error: false,
  success: false,
  successMessage: '',
  errorMessage: null,
};

const postCategoriesReducer = (state = postCategoriesDefaultState, action) => {
  switch(action.type) {
    case 'START_GET_POST_CATEGORIES':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'GET_POST_CATEGORIES_SUCCESS':
      return {
        ...state,
        data: action.postCategories,
        loading: false,
        error: false,
        errorMessage: null,
      };
    case 'START_GET_POST_CATEGORIES_BY_POST_IDS':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'GET_POST_CATEGORIES__BY_POST_IDS_SUCCESS':
      return {
        ...state,
        data: action.postCategories,
        loading: false,
        error: false,
        errorMessage: null,
      };
    case 'CREATE_POST_CATEGORY_SUCCESS':
      return {
        ...state,
        data: [
          action.post,
          ...state.data,
        ],
        loading: false,
        success: true,
        error: false,
        errorMessage: null,
        successMessage: 'Post Type has been added!',
      };
    case 'UPDATE_POST_CATEGORY_SUCCESS': // updating single post
      return {
        ...state,
        data: state.data.map((post) => {
          if (post.postId === action.post.postId) {
            console.log('got match');
            return {
              ...post,
              ...action.post /// add object to array
            }
          } else {
            return post;
          }
        }),
        loading: false,
        success: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'REMOVE_POST_TYPE_SUCCESS':
      return {
        ...state,
        data: state.data.filter(post => action.postId !== post.postId), // filter original state and return any that don't have the remove postId
        loading: false,
        success: true,
        error: false,
        errorMessage: null,
        successMessage: 'Your post has been removed',
      };
    case 'START_SAVE_POST_CATEGORY':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'SAVE_POST_CATEGORY_SUCCESS':
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        errorMessage: null,
        successMessage: 'Your postCategories has been saved!',
      };
    case 'START_REMOVE_POST_CATEGORY':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'REMOVE_POST_CATEGORY_SUCCESS':
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        errorMessage: null,
        successMessage: 'Your postCategories have been removed!',
      };
    case 'SHOW_POST_CATEGORY_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        successMessage: '',
        errorMessage: action.errorMessage
      };
    default:
      return state;
  }
};

export default postCategoriesReducer;